<template>
  <v-row>
    <v-col class="text-center">
      <p>Profile</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Profile",
};
</script>
